import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { TrainingVendorsRoutingModule } from './training-vendors-routing.module';
import { TrainingVendorsListComponent } from './training-vendors-list/training-vendors-list.component';
import { TrainingVendorsCreateComponent } from './training-vendors-create/training-vendors-create.component';

@NgModule({
  declarations: [TrainingVendorsListComponent, TrainingVendorsCreateComponent],
  imports: [
    CommonModule,
    TrainingVendorsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class TrainingVendorsModule { }
